module.exports = __webpack_public_path__ + "img/automobileSolutions_bg.400415f6.png";